import { UI_DIMENSIONS } from '@config/ui-dimensions';
import { CELL_RENDERER } from '../types';

const COMMON_WARN_MESSAGE_CLASS =
  'xvi-label-warn-style with-padding full-width';
const COMMON_ERROR_MESSAGE_CLASS =
  'xvi-label-error-style with-padding full-width';
const GENERAL_ERROR_MESSAGE_CLASS =
  'xvi-label-error-style with-padding full-width error-background';
const COMMON_GENERAL_MESSAGE_CLASS =
  'xvi-label-general-style with-padding full-width';
const COMMON_TEXT_GENERAL_MESSAGE_CLASS = 'xvi-label-text';
const COMMON_BOLD_LABEL_CLASS = 'xvi-bold-label';
const COMMON_WARN_ICON_COLUMN = {
  title: '',
  path: 'error',
  cellRenderer: CELL_RENDERER.icon_renderer,
  cellRendererParams: {
    iconClass: 'xvi-grid-warn-icon',
    icon: 'icon-warning',
  },
  hide: false,
  cellStyle: (params): any => {
    return { visibility: params.value ? 'show' : 'hidden' };
  },
  cellClass: 'cell-overflow-visible',
  width: UI_DIMENSIONS.columnSmallWidthIcon,
  maxWidth: 35,
  resizable: false,
};

const COMMON_ICONS_COLUMN = {
  title: '',
  path: 'iconsInfo',
  cellRenderer: CELL_RENDERER.icons_renderer,
  hide: false,
  cellClass: 'cell-overflow-visible',
  width: UI_DIMENSIONS.columnSmallWidthIcon,
  resizable: false,
  minWidth: UI_DIMENSIONS.columnSmallWidthIcon,
};

export {
  COMMON_WARN_MESSAGE_CLASS,
  COMMON_WARN_ICON_COLUMN,
  COMMON_ERROR_MESSAGE_CLASS,
  COMMON_ICONS_COLUMN,
  GENERAL_ERROR_MESSAGE_CLASS,
  COMMON_GENERAL_MESSAGE_CLASS,
  COMMON_TEXT_GENERAL_MESSAGE_CLASS,
  COMMON_BOLD_LABEL_CLASS,
};
